var React = require("react");
var $ = require('jquery');

var JobArea = require('./job_area');
var ApplyArea = require('./apply_area');
var JobApplyPopup = require('./job_apply_popup');
var JobApplyPopupBg = require('./job_apply_popup_bg');
var DisabledView = require('./disabled_view');

// App
module.exports = React.createClass({
	render: function(){
		
		if(this.props.env_info.settings.enable_job_listing){
	    	return (<div className="wrapper">	
					<JobApplyPopup env_info={this.props.env_info} env={this.props.env_name} job_id={this.props.job_data.job_id} job={this.props.job_data} />
					<JobApplyPopupBg />
					<JobArea env={this.props.env_name} env_info={this.props.env_info} job={this.props.job_data} />	
					<ApplyArea 
						env_info={this.props.env_info}
						env={this.props.env_name} 
						job={this.props.job_data} 
						other_jobs={this.props.other_jobs} />		
				</div>);
		} else {
			return (
				<div className="wrapper">	
					<DisabledView />	
				</div>
			);
		}
	}
});